import React from "react";
import { productGenderSizeMappingsApi } from "@/apis/apis";
import { columns } from "./Columns";
import MappingBaseTable from "../BaseTable";
import { BASE_IMPORT_DATA } from "@/Modals/WebDataManagement/Mapping/BaseImport/baseImportData";
import ProductGenderSizeModal from "@/Modals/WebDataManagement/Mapping/ProductGenderSize/Modal";

export default function ProductGenderSizePage() {
  return (
    <MappingBaseTable
      label="Product - Gender - Size"
      apiURL={productGenderSizeMappingsApi}
      columns={columns()}
      ModalComponent={ProductGenderSizeModal}
      importData={BASE_IMPORT_DATA.PRODUCT_GENDER_SIZE}
      modalDataName={""}
      enableAdd={true}
      enableEdit={false}
      enableDelete={true}
    />
  );
}
